/* eslint-disable */
import { useContext, useState } from "react";

import { CalendarDays, CheckCircle, PencilIcon } from "../../common/icons";
import axaSmallLogo from "../../assets/img/axa-logo-small.png";
import { LocalizationContext } from "../../App";
import { Formatters } from "../../common/helpers/formatters";

export const ActivateOffer = () => {
  const [step, setStep] = useState<number>(1);
  const [processStarted, setProcessStarted] = useState<boolean>(false);
  const confirmFirstStep = () => {
    setProcessStarted(true);
    setTimeout(() => setStep((s) => s + 1), 350);
  };
  const l10n = useContext(LocalizationContext);

  const annualPrice: number = 772.2;
  const coveragePerMonth: number = 1500;
  const quarterlyPrice: number = 192.05;
  const startDate: Date = new Date(2023, 11, 31);

  return (
    <>
      <h2>{l10n.title.provisionalQuote}</h2>

      {step === 1 && (
        <div className="w-full">
          <div className="w-full flex flex-1 flex-col pb-6 bg-white rounded-t-2xl justify-between">
            <div className="w-full flex flex-col justify-center items-center content-center">
              <div className="mr-4 mt-4 self-end">
                <PencilIcon className={"w-6 h-6 stroke-2"} />
              </div>
              <span className="mb-3 text-center text-body text-3xl font-semibold leading-9">
                {l10n.products.PPI.name}
              </span>
              <span className="mt-3 mb-6 text-center text-neutral-400 text-xs font-medium leading-none">
                {l10n.products.PPI.description}
              </span>

              <div className="w-2/3 h-10 p-0.5 bg-neutral-100 rounded-2xl justify-start items-center inline-flex">
                <div className="px-4 py-2 mr-2 bg-white rounded-2xl justify-start items-center gap-2 inline-flex text-center text-black text-sm font-normal leading-tight">
                  {l10n.label.monthly}
                </div>
                <div className="px-4 py-2 rounded-2xl justify-start items-center gap-2 inline-flex text-stone-300 text-sm font-normal leading-tight">
                  {l10n.label.quarterly}
                </div>
              </div>

              <div className="flex w-full px-6 mt-4">
                <div className="flex flex-1 py-4 px-6 bg-white rounded-2xl shadow-md justify-between">
                  <div className="flex flex-col">
                    <span className="text-neutral-500 text-xs font-medium leading-none">
                      {l10n.label.coveragePerMonth}
                    </span>
                    <span className="text-body mt-1 text-sm font-semibold leading-tight">
                      {Formatters.formatCurrencyNumber(coveragePerMonth)}
                    </span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-neutral-500 text-xs font-medium leading-none">
                      {l10n.label.coveragePerMonth}
                    </span>
                    <span className="text-body mt-1 text-sm font-semibold leading-tight">
                      {Formatters.formatCurrencyNumber(coveragePerMonth)}
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex w-full px-6 mt-4">
                <div className="flex flex-1 py-4 px-6 bg-white rounded-2xl shadow-md justify-between">
                  <div className="flex flex-col">
                    <span className="text-neutral-500 text-xs font-medium leading-none">
                      {l10n.label.startDate}
                    </span>
                    <span className="text-body mt-1 text-sm font-semibold leading-tight">
                      {Formatters.formatShortDate(startDate)}
                    </span>
                  </div>
                  <div className="flex flex-col justify-center">
                    <CalendarDays className={"w-6 h-6"} />
                  </div>
                </div>
              </div>
            </div>
            <span className="flex flex-row justify-between pl-7 ml-6 mt-6 w-40 h-9 px-3 bg-[#00008f] rounded-md text-white text-sm font-medium leading-tight">
              <span className="py-2">{l10n.products.PPI.name}</span>
              <img src={axaSmallLogo} height={32} width={32} />
            </span>
          </div>
          <div
            className="w-full flex flex-1 flex-row h-auto p-7 bg-zinc-100 rounded-b-2xl shadow-md justify-between items-center"
            onClick={() => confirmFirstStep()}
          >
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                value=""
                checked={processStarted}
                onChange={() => {}}
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
            </label>
            <span className="ml-3 text-black text-lg font-semibold leading-6">
              {l10n.label.byCheckingBoxReadUnderstoodTermsAndConditions}
            </span>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="w-full">
          <div className="flex w-full px-6 mt-4">
            <div className="flex flex-1 py-4 px-6 bg-white rounded-2xl shadow-md justify-between">
              <div className="flex flex-col">
                <span className="text-neutral-500 text-xs font-medium leading-none">
                  {l10n.label.annual}
                </span>
                <span className="text-body mt-1 text-sm font-semibold leading-tight">
                  {Formatters.formatCurrencyNumber(annualPrice)}
                </span>
              </div>
              <div className="flex flex-col justify-center">
                <CheckCircle className={"w-6 h-6 text-[#BCD700] stroke-2"} />
              </div>
            </div>
          </div>
          <div className="flex w-full px-6 mt-4">
            <div className="flex flex-1 py-4 px-6 bg-white rounded-2xl shadow-md justify-between">
              <div className="flex flex-col">
                <span className="text-neutral-500 text-xs font-medium leading-none">
                  {l10n.label.quarterly}
                </span>
                <span className="text-body mt-1 text-sm font-semibold leading-tight">
                  {Formatters.formatCurrencyNumber(quarterlyPrice)}
                </span>
              </div>
              <div className="flex flex-col justify-center"></div>
            </div>
          </div>

          <button className="btn btn-primary">
            {l10n.btn.confirmPassword}
          </button>
        </div>
      )}
    </>
  );
};
